import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const getStats = (setData) => {
  axiosInstance
    .get("/admin/dashboard/stats", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setData(res.data);
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};
export const getTableData = (setTableData) => {
  axiosInstance
    .get("/admin/dashboard/table", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setTableData(res.data);
    })
    .catch((err) => {
      toast.error("Something went wrong");
    });
};
